var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "contact__wrapper" }, [
      _c("div", { staticClass: "contact__wrapper__bg" }, [
        _c("div", { staticClass: "contact__wrapper__component" }, [
          _c("div", { staticClass: "satisfication__wrapper" }, [
            _c(
              "div",
              {
                staticClass:
                  "d-none d-sm-none d-md-block text-center satisfication__wrapper__elm"
              },
              [
                _c("div", { staticClass: "w-100" }, [
                  _c("h1", [
                    _vm._v(_vm._s(_vm.$root.trans(_vm.staticPage.name_key)))
                  ])
                ])
              ]
            )
          ])
        ])
      ]),
      _c("div", { staticClass: "contact__wrapper__elm" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", {
            staticClass: "col-md-12",
            domProps: { innerHTML: _vm._s(_vm.staticPage.body) }
          })
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b00ef05", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b00ef05","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/_lang/page/_slug.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0b00ef05","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/_lang/page/_slug.vue
// module chunks = 19